'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('../constants');

var defaultRollback = {
  type: _constants.DEFAULT_ROLLBACK
};
exports["default"] = defaultRollback;